import json from './json.js';
import label from './label.js';
export default Object.assign({}, json, label);